export default "__VITE_ASSET__BMT1ohOh__"